import React from 'react'
import Logo from '../assets/images/logo.png'

function Seeyou () {
  return (
    <div
      id='faq'
      className='section-padding bg-img bg-fixed'
    >
      <div className='container'>
      <div className='row'>
          <div
            className='col-md-12 text-center animate-box'
            data-animate-effect='fadeInUp'
          >
            <h3 className='oliven-couple-title'>Frequently Asked Questions</h3>
            <br></br>
            <h3><b>Can I bring a plus one?</b></h3>
            <h4 className='oliven-couple-subtitle'>We have extended plus ones to friends and family we know require plus ones. Please reach out to us if you'd like to bring one.</h4>
            <br></br>
            <h3><b>Are there drinks?</b></h3>
            <h4 className='oliven-couple-subtitle'>Our wedding will have an OPEN BAR. It will also be heavily photographed and any drunken shenanigans will be mocked for years to come. Please proceed with caution ;)</h4>
            <br></br>
            <h3><b>Where should I park?</b></h3>
            <h4 className='oliven-couple-subtitle'>Please refer to the when & where section. The wedding bowl at culvier park is walking distance from La Jolla Women's club.</h4>
            <br></br>
            <h3><b>Is this family friendy?</b></h3>
            <h4 className='oliven-couple-subtitle'>YES, we'd like to celebrate with everyone, but please be mindful</h4>
            <br></br>
            <h3><b>What date should I RSVP by?</b></h3>
            <h4 className='oliven-couple-subtitle'>You MUST RSVP 3 weeks prior to the wedding date, but we (strongly) prefer it if you fill it out early </h4>
            <br></br>
            <h3><b>What time will the reception end?</b></h3>
            <h4 className='oliven-couple-subtitle'>This is a morning wedding and will be ending at 5pm.</h4>
            <br></br>
            <h3><b>Am I allowed to take photos at the wedding?</b></h3>
            <h4 className='oliven-couple-subtitle'>Please only take photos during the brunch and reception portions of the wedding. Refrain from using any electronics during ceremonies.</h4>
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default Seeyou
